import { imgixHost } from 'src/config'

export const createSiteSelectorItem = () => {
  return {
    key: crypto.getRandomValues(new Uint32Array(1))[0],
    name: '',
    address: '',
    siteId: null,
    image: null,
    displayOrder: 100,
    externalUrl: null
  }
}

export function siteSelectorItemImageUrl (imageKey) {
  if (!imageKey) return null

  return `${imgixHost}/${imageKey}?fit=crop&w=600&h=400&fm=jpeg&auto=format`
}
